import gsap from 'gsap'
import splitLine from '../utils/split-line'

// Simple debounce utilitaire
function debounce(fn, wait = 200) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => fn.apply(this, args), wait)
  }
}

// Détection mobile
const isMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  return /iphone|ipod|ipad|android|blackberry|windows phone|webos/i.test(userAgent)
}

// Fonction d'animation (split + timeline GSAP)
const animateLines = (element, delay = 50) => {
  // Découper les lignes
  splitLine(element)
  const lines = element.querySelectorAll('._y .line')
  if (lines.length === 0) return

  // Positionner initialement
  gsap.set(lines, { yPercent: 100 })

  // Créer la timeline uniquement si elle n'existe pas encore
  if (!element._timeline) {
    const timeline = gsap.timeline({
      paused: true,
      onComplete: () => {
        element.classList.add('visible')
      },
      onReverseComplete: () => {
        element.classList.remove('visible')
      }
    })

    lines.forEach((line, index) => {
      timeline.to(line, {
        yPercent: 0,
        duration: 0.8,
        ease: 'power3.out',
      }, index * delay / 1000)
    })

    element._timeline = timeline

    // Gérer les events qu'une seule fois
    document.addEventListener('AnimateLines', (data) => {
      if (data?.detail?.elements) {
        data.detail.elements.forEach(e => {
          if (element === e) {
            element._timeline.play()
          }
        })
      }
    })

    document.addEventListener('AnimateLinesReverse', (data) => {
      if (data?.detail?.elements) {
        data.detail.elements.forEach(e => {
          if (element === e) {
            element._timeline.reverse()
          }
        })
      }
    })
  }
}

// Initialisation de tous les éléments
const init = () => {
  document.querySelectorAll('[animate-lines]').forEach(element => {
    if (!element.classList.contains('animate-lines--init')) {
      element.classList.add('animate-lines--init')
      // Sauvegarder l'HTML original pour le resize
      if (!element.dataset.originalHtml) {
        element.dataset.originalHtml = element.innerHTML
      }
      animateLines(element)
    }
  })
}

// Fonction de refresh uniquement sur desktop
const refresh = debounce(() => {
  if (!isMobile()) {
    document.querySelectorAll('[animate-lines]').forEach(element => {
      if (element.dataset.originalHtml) {
        element.innerHTML = element.dataset.originalHtml
      }
      // NE PAS recréer la timeline ni réécouter les events
      delete element._timeline
      animateLines(element)
    })
  }
}, 200)

// Export principal
export default () => {
  init()
}